import { useParams } from 'react-router-dom';
import ParchmentCard from '@/components/ui/ParchmentCard';

export default function AdminPlaceholderPage() {
  const { section } = useParams();

  return (
    <section>
      <h1 className="font-serif text-2xl font-black capitalize text-accent">{section?.replace('-', ' ')}</h1>
      <ParchmentCard className="mt-5 text-fg">
        CRUD administrativo preparado para a fase seguinte.
      </ParchmentCard>
    </section>
  );
}
